import styled from 'styled-components';

export const PageTitleStyled = styled.div`
  display: flex;
  gap: 16px;
  padding: 24px 24px 16px 24px;
  align-items: center;

  .title {
    h1 {
      font-size: 32px;
      font-weight: 600;
      line-height: 40px;
      letter-spacing: -0.02em;
      color: ${({ theme }) => theme.colors.gray[80]};
      margin: 0;
      padding: 0;
    }
  }

  .actions {
    flex-grow: 1;
  }
`;

export const PageTitleActionsStyled = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: flex-end;
`;
